import { render } from "./CreateCategory.vue?vue&type=template&id=9ca94600&scoped=true"
import script from "./CreateCategory.vue?vue&type=script&lang=js"
export * from "./CreateCategory.vue?vue&type=script&lang=js"

import "./CreateCategory.vue?vue&type=style&index=0&id=9ca94600&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca94600"]])

export default __exports__